import React from 'react'
import ClassNames from 'classnames'

import { TextEditorStyle } from './styled'

//https://github.com/summernote/react-summernote
import ReactSummernote from 'react-summernote'
import 'react-summernote/dist/react-summernote.css' // import styles
import 'react-summernote/lang/summernote-ru-RU' // you can import any other locale

import jquery from 'jquery'
import 'bootstrap3/js/modal'
import 'bootstrap3/js/dropdown'
import 'bootstrap3/js/tooltip'

// import 'bootstrap3/dist/css/bootstrap.css'

window.jQuery = jquery
window.jquery = jquery
window.$ = jquery

export class TextEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      autoClose: 5000,
    }
  }

  render() {
    const { className } = this.state
    return (
      <TextEditorStyle className="text-editor-wrapper">
        <ReactSummernote
          {...this.props}
          className={ClassNames('text-editor', className)}
        />
      </TextEditorStyle>
    )
  }
}
